import * as React from 'react'

import { cn } from '@/lib/utils'
import useLocale from '@/hooks/use-locale'

import { FeedbackType } from '@/data/feedback'

import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import { Card, CardContent, CardFooter, CardHeader } from '../ui/card'
import { Separator } from '../ui/separator'

function InformationUser({ keyInfo, info }: { keyInfo: string; info: string }) {
  return (
    <div className="flex justify-between text-slate-700 w-full">
      <p className="text-base">{keyInfo}</p>
      <p className="text-base">{info}</p>
    </div>
  )
}

export default function FeedbackCard({ feedback, className }: { feedback: FeedbackType; className?: string }) {
  const { lang } = useLocale()
  return (
    <Card className={cn('flex flex-1 flex-col h-full justify-between', className)}>
      <div className="mb-6">
        <CardHeader>
          <div className="flex items-center space-x-3">
            <Avatar className="h-14 w-14">
              <AvatarImage src={feedback.author.avatar} alt={feedback.author.username} className="object-cover" />
              <AvatarFallback>{feedback.author.username}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col items-start justify-center space-y-1">
              <p className="text-center text-base font-medium">{feedback.author.username}</p>
            </div>
          </div>
        </CardHeader>
        <CardContent className="min-h-60">
          <p className="text-base text-accent-foreground/80">{feedback.message}</p>
        </CardContent>
      </div>
      <CardFooter className="flex flex-col">
        <div className="py-8 w-full">
          <Separator />
        </div>
        <div className="space-y-4 w-full">
          <InformationUser
            keyInfo={lang === 'vi' ? '🤖 Kinh nghiệm' : '🤖 Experience'}
            info={feedback.author.experience}
          />
          <InformationUser keyInfo={lang === 'vi' ? '🏢 Công ty' : '🏢 Company'} info={feedback.author.company} />
          <InformationUser keyInfo={lang === 'vi' ? '💻 Vị trí' : '💻 Position'} info={feedback.author.position} />
          <InformationUser keyInfo={lang === 'vi' ? '🎓 Học viên' : '🎓 Student'} info={feedback.author.course} />
        </div>
      </CardFooter>
    </Card>
  )
}
